import { $api } from '@shared/api';
import { handleAxiosFetchErrorsSwal } from '@shared/helpers/fetchHelpers';

export const createAdminConversationCategory = async () => {
    // @ts-ignore
    const url = routable.getRoute('adminCommunicationCategoryCreate');

    const formData = new FormData();
    formData.append('title', 'Новая категория');

    try {
        // @ts-ignore
        loader.show();
        const response = await $api.post(url, formData);
        // @ts-ignore
        loader.hide();
        return response;
    } catch (error) {
        // @ts-ignore
        loader.hide();
        handleAxiosFetchErrorsSwal(error?.response?.data);
        return error.message;
    }
};
